export default "__VITE_ASSET__TumbjEkH__"